import { Menu } from 'lucide-react'
import { memo, useCallback } from 'react'
import { useAppDispatch, useAppSelector } from '@/lib/hooks'
import { toggleSidebar } from '@/features/ui/uiSlice'
import UserMenu from './UserMenu'

const Header = memo(function Header() {
  const dispatch = useAppDispatch()
  const { isMobile: _isMobile } = useAppSelector((state) => state.ui)

  // 🎯 SIMPLIFIED: Only sidebar toggle needed
  const handleSidebarToggle = useCallback(() => {
    dispatch(toggleSidebar())
  }, [dispatch])

  return (
    <header 
      className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-xl border-b border-gray-200/50 dark:border-gray-700/50 shadow-sm"
      style={{ height: 'var(--layout-header-height)' }}
    >
      <div className="flex items-center justify-between h-full px-6 sm:px-8">
        {/* Left: Menu toggle */}
        <div className="flex items-center space-x-4">
          <button
            onClick={handleSidebarToggle}
            className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-100/80 dark:hover:bg-gray-700/50 dark:hover:text-gray-300 transition-all duration-300 hover:scale-105"
            aria-label="Toggle sidebar"
          >
            <Menu className="h-5 w-5 sm:h-6 sm:w-6" />
          </button>
          
          {/* Mobile Title */}
          <h1 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white lg:hidden bg-gradient-to-r from-primary-600 to-accent-600 bg-clip-text text-transparent">
            feedbeq
          </h1>
        </div>

        {/* Right: User menu */}
        <UserMenu />
      </div>
    </header>
  )
})

export default Header 